<template>
  <div class="loginContainer">
    <van-popup v-model="loginShow" @close="close">
      <div class="login">
        <h2 class="loginTitle">登录</h2>

        <van-form validate-first @failed="onFailed" @submit="submit">
          <!-- 通过 pattern 进行正则校验 -->
          <div class="flex">
            <van-image width="16" height="16" :src="iconUrl" />
            <van-field
              type="number"
              v-model="phone"
              name="pattern"
              placeholder="请输入您的手机号"
              maxlength="11"
              :error-message="phoneText"
            />
          </div>
          <div class="flex">
            <div>
              <van-image width="16" height="16" :src="iconCode" />
            </div>
            <van-field
              type="number"
              v-model="code"
              name="patternCode"
              placeholder="请输入验证码"
              :rules="[{ patternCode, message: '验证码错误' }]"
            />
            <!-- @click="getCode"   @submit='submit'-->
            <van-button class="codeButton" @click="getCode" :disabled="btnDisabled">
              <span v-show="!btnDisabled">{{codeText}}</span>
              <span v-show="btnDisabled">{{second}}秒</span>
            </van-button>
          </div>
          <div style="margin-top: 16px;">
            <van-button round block type="info" native-type="submit">登录</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>
<script>
//import { Dialog } from "vant";
import { PhoneCode, UserLogin } from "@/api/login.js";
//import { TimeSecond } from "@/utils/public.js";
import { Notify } from "vant";
//setToken
import { setTokenTime } from "@/utils/auth.js";

import uni from "@/utils/uni.webview.1.5.2.js";

export default {
  name: "login",
  props: {
    loginShow: {
      type: Boolean
    }
  },
   created () {
          //已登录状态再进入登陆页面，直接跳转到管理首页。不允许登陆状态再次登陆
          // let token = localStorage.getItem('Authorization');
          // if (token != null || token != '') {
          //     this.$router.push({ path: "/orderReceiving" });
          // }
      },
  data() {
    return {
      phone: "",
      code: "",
      codeText: "获取验证码",
      phoneText: "",
      patternCode: /^[\u0660-\u0669]/,
      iconUrl: require("../../../assets/home/loginUser.png"),
      iconCode: require("../../../assets/home/code.png"),
      second: 60, //秒
      btnDisabled: false, //禁用点击
      setIntervalTime: null, //定时器
      AppId: "gccx10b8327831aeb9" //区分那个端口
    };
  },
  watch: {
    second: function(newValue) {
      if (newValue === 0) {
        this.codeText = "获取验证码";
        this.btnDisabled = false;
        this.second = 60;
        clearInterval(this.setIntervalTime);
      }
    }
  },
  methods: {
	isWexin() {
			let isWechat = false;
			var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
			if (ua.match(/MicroMessenger/i) == "micromessenger") {
					isWechat = true;
			}
			return isWechat;
	},
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    getCode() {
      let textPhone = /^1[3|4|5|6|7|8|9]\d{9}$/;

      let phoneState = textPhone.test(this.phone);

      if (!phoneState) {
        return (this.phoneText = "手机格式有误");
      }
      this.btnDisabled = true;
      this.phoneText = "";
      //定时器
      this.setIntervalTime = setInterval(() => {
        this.second--;
      }, 1000);
      PhoneCode(this.phone).then(res => {
        if (res.data.code !== "0") {
          Notify("手机号无效或达到限制次数");
        }
      });
    },
    //登录
    submit(values) {
      let userObj = {
        client_id: this.AppId,
        phone: values.pattern,
        verificationCode: values.patternCode
      };
      UserLogin(userObj).then(res => {
        let result = res.data;
        if (result.msg === "登录成功" && result.success) {
          this.$store.state.access_token =
            result.data.accessToken.token_type +
            " " +
            result.data.accessToken.access_token;
          let tokeContainer =
            result.data.accessToken.token_type +
            " " +
            result.data.accessToken.access_token;
          setTokenTime(tokeContainer);
		  this.$emit("close", false);
		  
		  let self = this;
		  
		  let isWechat = self.isWexin();
		  
		  let isWxapp = false;
		  if(isWechat && wx.miniProgram) {
		  	  wx.miniProgram.getEnv(function (res) { //getEnv获取环境
		  		if (res.miniprogram) {
		  			isWxapp = true;
		  			uni.postMessage({
		  				data: {
		  					accessToken: result.data.accessToken.access_token
		  				}
		  			  });
		  			// uni.navigateBack({
		  			// 	delta: 1
		  			//   });
		  		} 
		  	  })
		  } 
		  return;
        }
      });
    },
    close() {
      this.$emit("close", false);
    }
  }
};
</script>
<style lang="scss" scoped>
$gray3: #333;
$grayF4: #f4f0f3;
$red: #fd503b;
$bgf: #fff;
.loginContainer {
  text-align: center;
  .loginTitle {
    font-size: 50px;
    font-weight: 500;
    color: $gray3;
  }
  .flex {
    border-bottom: 1px solid $grayF4;
    // height:150px;
  }
  .van-popup {
    box-sizing: border-box;
    padding: 0 60px 46px;
    width: 90%;
    border-radius: 22px;
  }
  .van-button--info {
    background: $red;
    border: 1px solid $red;
  }
  .codeButton {
    box-sizing: border-box;
    width: 380px;
    height: 60px;
    padding: 0;
    font-size: 30px;
    background: $red;
    color: $bgf;
    border-radius: 60px;
    cursor: pointer;
  }
}
</style>